import measurementService from '../service/measurement'

const state = {
    trend: '',
    loading: false,
    trendCache: {
        pointId:'', dateRange:[] , filters:[]
    },
    activeData:'',
    trendTelemetry: ""
}

const actions = {
    updateActiveData({commit},{activeData}){
        commit('setActiveData',activeData)
    },

    getTrend({ commit }, { pointId, dateRange , filters, measurementType}) {
        commit('setTrendCache', { pointId,dateRange ,filters})
        commit('setLoading', true)
        return measurementService.getTrend(pointId, dateRange, filters, measurementType)

            .then(trend => {
                commit('setTrend', trend)
            }).catch((e) => {
                console.log("error", e)
            }).finally(() => commit('setLoading', false))
    },
}
const mutations = {
    setTrendCache(state, { pointId, dateRange , filters }) {
        state.trendCache = {
            pointId, dateRange , filters
        }
    },
    setActiveData(state, activeData) {
        state.activeData = activeData
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setTrend(state, trend) {
        state.trend = trend
        state.loading = false
    },
    setTrendTelemetry(state, trendTelemetry) {
        state.trendTelemetry = trendTelemetry
    }

}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}
